<template>
  <div class="loader-container">
    <div class="loader-icon">
      <div v-if="spinner" class="spinner" />
      <Loader v-else :height="'6vh'" />
    </div>
    <div v-if="showText" class="loader-text">
      {{ loadingText }}
    </div>
  </div>
</template>

<script>
import Loader from './Loader.vue';

export default {
  name: 'MonogramLoader',
  components: {
    Loader,
  },
  props: {
    text: { type: Array, default: () => [] },
    showText: { type: Boolean, default: false },
    spinner: { type: Boolean, default: false },
  },
  computed: {
    loadingText() {
      const r = this.getRandomNumber(1, this.text.length) - 1;
      return this.text[r];
    },
  },
  methods: {
    getRandomNumber(min, max) {
      return (Math.random() * (max - min) + min).toFixed(0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/config.scss";

.loader-container {
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items: center;
}

.loader-text {
  font-family: $font-family-grotesk;
  color: $darkBlack;
  font-weight: 400;
  font-size: 22px;
  text-align: center;
  margin-top: 32px;
  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
}

.spinner {
  border: 6px solid $stoneDark;
  border-top: 6px solid $darkBlack;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
  opacity: 0.7;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
